<h1 *ngIf="prevPage === 'duplicates'">{{'cs.sys.duplicates.check.duplicatesPageTitle' | hisUi}}</h1>

<his-dialog-header
	[showCustomButton]="showEditButton && (hasEditRights || hasChangeRequestRights)"
	[customButtonLabel]="'common.edit'"
	[showResetButton]="false"
	[showSaveButton]="false"
	[showBackButton]="showBackButton"
    [showSearchButton]="showSearchButton"
	(customEvent)="edit()">
  	<!-- Bedienelemente im "Mehr..." -->
  	<ng-container customButtons>
        <button *ngIf="prevPage === 'duplicates'" type="button" [title]="'cs.sys.duplicates.check.backToDuplicatesPage' | hisUi" (click)="back()">{{'cs.sys.duplicates.check.backToDuplicatesPage' | hisUi}}</button>
        <button *ngIf="prevPage === 'importCandidates'" type="button" [title]="'fs.res.publication.import.candidates.back' | hisUi" (click)="back()">{{'fs.res.publication.import.candidates.back' | hisUi}}</button>

		<his-display-webshare [btnTitle]="'cs.sys.webshare.publication'" [title]="publication.title"
				[text]="publication.title" [url]="getUrl()"></his-display-webshare>
  	</ng-container>
</his-dialog-header>

<div *ngIf="publication.id" class="layoutBlock detailpage">
	<div class="detailpageSideLeft">
		<div class="circleIconContainer">
			<div class="circle-icon">
				<div>
                    <img *ngIf="!isDuplicate" hisImage="PUBLICATION" class="inlineicon" title="{{'fs.res.publication.Publication' | hisUi}}">
                    <img *ngIf="isDuplicate" hisImage="publication_duplicate" class="inlineicon" title="{{'cs.sys.duplicates.check.potentialDuplicate' | hisUi}}">
                </div>
			</div>
		</div>
	</div>
	<div class="detailpageCenter">
		<res-publication-view-details-vcard
			[publication]="publication"
			[showParentLink]="showParentLink"
			[checkedPersonIdsForRights]="personRights">
		</res-publication-view-details-vcard>

		<res-collapsible-text-view
			text="{{ publication | hisTranslate : 'textAbstract'}}"
			[hisobject] ="publication"
			[hisAttribute] = "'textAbstract'"
			header="fs.res.publication.abstract"
			expandToolTip="fs.res.publication.view.showFullAbstract"
			collapseToolTip="fs.res.publication.view.showShortAbstract">
		</res-collapsible-text-view>

		<!-- TODO: Sortierung der Anzeige der Identifier, momentan Reihenfolge Anzeige = Reihenfolge Eingabeliste -->
		<div *ngIf="!isEmpty(publication.globalIdentifiers)" class="links">
			<ng-container *ngFor="let identifier of publication.globalIdentifiers" [ngSwitch]="identifier.globalIdentifierType.hiskeyId">
				<ng-container *ngSwitchCase="identifierEnum.PMID">
					<a href="{{identifierEnum.PMID_PATH}}{{identifier.identifier}}" class="transparent pubmed" title="{{'fs.res.publication.GlobalIdentifier.accessLink.pubMed.help' | hisUi}}">PubMed</a>
					<a *ngIf="!findIdentifierByHiskeyId(identifierEnum.PMCID)"href="{{identifierEnum.PMID_PMC_PATH}}{{identifier.identifier}}" class="transparent europepmc" title="{{'fs.res.publication.GlobalIdentifier.accessLink.euroPubMed.help' | hisUi}}">Europe PMC</a>
				</ng-container>
				<a *ngSwitchCase="identifierEnum.PMCID" href="{{identifierEnum.PMCID_PATH}}{{identifier.identifier}}" class="transparent europepmc" title="{{'fs.res.publication.GlobalIdentifier.accessLink.euroPubMed.help' | hisUi}}">Europe PMC</a>
				<!-- URL-Identifier brauchen kein PATH-Prefix -->
				<a *ngSwitchCase="identifierEnum.URL" href="{{identifier.identifier}}" hisImage="world" class="transparent">URL</a>
			</ng-container>
		</div>
		<res-publication-citation-dialog [citations]="publication.citations" [publication]="publication"></res-publication-citation-dialog>
		<br>
		<br>
		<div class="details">
			<div class="detailPresentationList">
				<ng-container *ngIf="!isEmpty(publication.globalIdentifiers)">
					<ng-container *ngFor="let identifier of publication.globalIdentifiers">
						<div *ngIf="isAnalogIdentifier(identifier)" class="layoutBlock detailPresentationListItem">
							<div class="columnDetailLabel detailPresentationListLabel"><span>{{identifier.globalIdentifierType.text}}</span></div>
							<div class="columnDetailContent detailPresentationListContent"><span>{{identifier.identifier}}</span></div>
						</div>
					</ng-container>
				</ng-container>
			 	<div *ngIf="publication.conference" class="layoutBlock detailPresentationListItem">
					<div class="columnDetailLabel detailPresentationListLabel"><span #ddKey [hisDdKey]="getDdKey('conference')">{{ddKey.ddLabeltext | hisUi}}</span></div>
					<div class="columnDetailContent detailPresentationListContent"><his-translated-text [hisobject]="publication.conference" hisAttribute="defaulttext"></his-translated-text></div>
				</div>
				<div *ngIf="!isEmpty(publication.languages)" class="layoutBlock detailPresentationListItem">
					<div class="columnDetailLabel detailPresentationListLabel">
						<span *ngIf="1 < publication.languages.length; else singular">{{'common.i18n.LanguageValue' | hisUi}}</span>
						<ng-template #singular><span>{{'fs.res.common.language' | hisUi}}</span></ng-template>
					</div>
					<div class="columnDetailContent detailPresentationListContent">
						<ng-container *ngFor="let language of publication.languages; index as i, last as lastLanguage">
							{{language.text}}<span *ngIf="!lastLanguage">, </span>
						</ng-container>
					</div>
				</div>
				<div *ngIf="publication.series" class="layoutBlock detailPresentationListItem" [hisDdKey]="getDdKey('series')">
					<div class="columnDetailLabel detailPresentationListLabel"><span #ddKey [hisDdKey]="getDdKey('series')">{{ddKey.ddLabeltext | hisUi}}</span></div>
					<div class="columnDetailContent detailPresentationListContent">
						<span>
							<span *ngIf="publication.series">{{publication.series}}</span>
							<span *ngIf="publication.series && publication.numberInSeries"> ; </span>
							<span *ngIf="publication.numberInSeries">{{publication.numberInSeries}}</span>
						</span>
					</div>
				</div>
				<div *ngIf="publication.edition" class="layoutBlock detailPresentationListItem" [hisDdKey]="getDdKey('edition')">
					<div class="columnDetailLabel detailPresentationListLabel"><span #ddKey [hisDdKey]="getDdKey('edition')">{{ddKey.ddLabeltext | hisUi}}</span></div>
					<div class="columnDetailContent detailPresentationListContent"><span>{{publication.edition}}</span></div>
				</div>
                <div *ngIf="publication.numberOfPages" class="layoutBlock detailPresentationListItem">
					<div class="columnDetailLabel detailPresentationListLabel"><span #ddKey [hisDdKey]="getDdKey('numberOfPages')">{{ddKey.ddLabeltext | hisUi}}</span></div>
					<div class="columnDetailContent detailPresentationListContent"><span>{{publication.numberOfPages}}</span></div>
				</div>
				<div *ngIf="publication.publicationResource?.text" class="layoutBlock detailPresentationListItem">
					<div class="columnDetailLabel detailPresentationListLabel"><span #ddKey [hisDdKey]="getDdKey('publicationResource')">{{ddKey.ddLabeltext | hisUi}}</span></div>
					<div class="columnDetailContent detailPresentationListContent"><span>{{publication.publicationResource.text}}</span></div>
				</div>
                <div *ngIf="publication.license?.defaulttext" class="layoutBlock detailPresentationListItem">
					<div class="columnDetailLabel detailPresentationListLabel"><span #ddKey [hisDdKey]="getDdKey('license')">{{ddKey.ddLabeltext | hisUi}}</span></div>
					<div class="columnDetailContent detailPresentationListContent"><span>{{publication.license.defaulttext}}</span></div>
				</div>
				<div class="layoutBlock detailPresentationListItem">
					<div class="columnDetailLabel detailPresentationListLabel"><span>{{'value.SubjectAreaValue' | hisUi}}</span></div>
					<div class="columnDetailContent detailPresentationListContent wordBreak">
						<span *ngFor="let subjectArea of publication.subjectAreas">
							<a [routerLink]="['/pub/searchresult']"
								[queryParams]="{configFile: 'fs/res/searchPublicationHeadless.xml', pageTitle: 'fs.res.publication.search.data',
								tableTitle: 'fs.res.publication.search.found', 'Publication.subjectAreas.id[]': getGenericValueIdForQueryParams(subjectArea), 'extended': true, showBackButton:true, isNotActiveSearch:true}"
								hisImage="tag_orange"
								class="singleLine transparent"
								title= "{{'fs.res.common.showResearchObjectsWithSubjectArea'|hisUi :('fs.res.common.publications'|hisUi |hisLowerCaseFirstLetter) : subjectArea.text}}"
								(click)="onBeforeNavigate()">{{subjectArea.text}}</a>
						</span>
					</div>
				</div>
                <div *ngIf="!isEmpty(publication.researchAreasKdsf)" class="layoutBlock detailPresentationListItem">
                    <div class="columnDetailLabel detailPresentationListLabel"><span>{{'fs.res.common.researchAreasKdsf' | hisUi}}</span></div>
                    <div class="columnDetailContent detailPresentationListContent wordBreak">
                        <span *ngFor="let researchAreaKdsf of publication.researchAreasKdsf">
                            <a [routerLink]="['/pub/searchresult']"
                                [queryParams]="getResearchAreaKdsfQueryParams(researchAreaKdsf)"
                                hisImage="tag_orange"
                                class="singleLine transparent"
                                title="{{'fs.res.common.showResearchObjectsWithResearchAreaKdsf'|hisUi:('fs.res.common.publications'|hisUi |hisLowerCaseFirstLetter) :researchAreaKdsf.text}}"
                                (click)="onBeforeNavigate()">{{researchAreaKdsf.text}}</a>
                        </span>
                    </div>
                </div>
                <div *ngIf="!isEmpty(publication.researchAreas)" class="layoutBlock detailPresentationListItem">
                    <div class="columnDetailLabel detailPresentationListLabel"><span>{{'value.ResearchAreaValue' | hisUi}}</span></div>
                    <div class="columnDetailContent detailPresentationListContent wordBreak">
                        <span *ngFor="let researchArea of publication.researchAreas">
                            <a [routerLink]="['/pub/searchresult']"
                                [queryParams]="getResearchAreaQueryParams(researchArea)"
                                hisImage="tag_orange"
                                class="singleLine transparent"
                                title="{{'fs.res.common.showResearchObjectsWithResearchArea'|hisUi: ('fs.res.common.publications'|hisUi |hisLowerCaseFirstLetter) : researchArea.text}}"
                                (click)="onBeforeNavigate()">{{researchArea.text}}</a>
                        </span>
                    </div>
                </div>
				<div *ngIf="!isEmpty(publication.keyWords)" class="layoutBlock detailPresentationListItem">
					<div class="columnDetailLabel detailPresentationListLabel"><span>{{'fs.res.publication.Publication.keywords' | hisUi}}</span></div>
					<div class="columnDetailContent detailPresentationListContent wordBreak">
						<span *ngFor="let key of publication.keyWords">
							<a [routerLink]="['/pub/searchresult']"
								[queryParams]="{configFile: 'fs/res/searchPublicationHeadless.xml', pageTitle: 'fs.res.publication.search.data',
								tableTitle: 'fs.res.publication.search.found', 'Publication.keyWords.defaulttext': key.defaulttext, 'extended': true, showBackButton:true, isNotActiveSearch:true}"
								hisImage="tag_orange"
								class="singleLine transparent"
								title="{{'fs.res.common.showResearchObjectsWithKeyword'|hisUi : ('fs.res.common.publications'|hisUi |hisLowerCaseFirstLetter) : key.text}}"
								(click)="onBeforeNavigate()">{{key.text}}</a>
						</span>
					</div>
				</div>
				<div *ngIf="rights.checkPublicationCommentRights() && publication.commentary" class="layoutBlock detailPresentationListItem">
					<div class="columnDetailLabel detailPresentationListLabel"><span>{{'fs.res.publication.Publication.commentary' | hisUi}}</span></div>
					<div class="columnDetailContent detailPresentationListContent">
						<span>{{publication.commentary}}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!--Platzhalter für leere rechte Spalte-->
	<div class="detailpageSideRight"></div>
</div>

<!-- HIS-Listview, wenn Listview gefüllt in publication-->
<ng-container *ngIf="publication.listviews">
	<his-listview [listviewKeys]="['projects', 'researchInfrastructures']" [listviewData]="publication.listviews"></his-listview>
</ng-container>
